setLiveAccessChatBlockedUsers